export default __webpack_public_path__ + "static/media/a028-2.a7ef9c3b.svg";